const initialCartState = {
  cart: [],
  cartCount: 0,
  showCheckout: false,
  fields: [],
  order: null,
  totals: null,
  placedAt: "",
  shippingAddress: {},
  submitted: false,
  pageLoaded: false,
  fieldsReloaded: false,
  cartLoaded: true,
  specialInstructions: "",
  newAddress: {
    customer_key: "",
    name: "",
    street_1: "",
    street_2: "",
    city: "",
    state: "",
    zip_code: "",
    country_code: "US",
  },
  newCreditCard: {
    Name: "",
    Number: "",
    ExpirationMonth: "",
    ExpirationYear: "",
    Cvv: "",
  },
};

const initialCreateAccountState = {
  pageLoaded: false,
  formFilled: false,
  accountCreated: false,
  formFields: [],
  reCAPTCHA: {},
  formInfo: {},
  businessLicense: {},
  formtitle: "",
  formtext: "",
  formimage: "",
};

const initialFormState = {
  formtitle: "",
  formtext: "",
  formimage: null,
  diamondshippingtitle: "",
  diamondshippingtext: "",
  shippingstates: [],
  isLoaded: false,
  fields: [],
  formInfo: {},
  addressFields: [],
  submitted: false,
  message: "",
  estimates: [],
  quoteId: 0,
};

const initialProductSearchState = {
  fields: [],
};

const initialProductLandingState = {
  products: [],
  filters: [],
  searchQuery: initialProductSearchState,
  pageLoaded: false,
  itemsLoaded: false,
  showFilters: false,
  bestSellers: false,
  clearAll: false,
};

const initialProductState = {
  pageLoaded: false,
  priceLoaded: false,
  message: "",
  messageType: "",
  style: "",
  productGroup: "",
  specialInstructions: "",
  productInfo: {},
  productFields: [],
  productTreatments: [],
  compatibleProducts: [],
  relatedProducts: [],
  icons: [],
  productSeries: {},
  price: null,
  productDetails: [],
  images: [],
  priceBreaks: [],
  daysToShip: "",
  estimatedShipDate: "",
  mto: false,
  metalColumns: {
    left: "",
    middle: "",
    right: "",
  },
  TopText: "",
  BottomText: "",
  ChartSizeSmall: false,
  strapiChart: null,
  sizeType: "standard",
  charmDimension: "",
  circleDimension: "",
  clear: false,
  validationErrors: [],
};

const initialBarState = {
  message: "",
  messageType: "",
  pageLoaded: false,
  priceLoaded: false,
  modalOpen: false,
  initialGroup: "",
  matchingGroup: "",
  queryString: "",
  setting: {
    style: "",
    settingInfo: {
      description: "",
      dimension: "",
      caratSize: "",
      customer_key: null,
      errors: [],
      fingerSize: "",
      material: "",
      message: "",
      product: "",
      quantity: null,
      quantityUnit: "",
      treatments: "",
    },
    settingFields: [],
    settingTreatments: [],
    compatibleProducts: [],
    relatedProducts: [],
    icons: [],
    settingSeries: {},
  },
  shank: {
    style: "",
    shankInfo: {
      description: "",
      dimension: "",
      caratSize: "",
      customer_key: null,
      errors: [],
      fingerSize: "",
      material: "",
      message: "",
      product: "",
      quantity: null,
      quantityUnit: "",
      treatments: "",
    },
    shankFields: [],
    shankTreatments: [],
    compatibleProducts: [],
    relatedProducts: [],
    icons: [],
    shankSeries: {},
  },
  diamond: {},
  ring: {
    price: null,
    partcode: {},
    ringDetails: [],
    images: [],
    pricebreaks: [],
    daysToShip: "",
    estimatedShipDate: "",
    mto: false,
  },
};

const initialDiamondSearch = {
  fields: [
    {
      name: "MinedOrLab",
      values: [{ name: "M" }],
    },
  ],
  sort: {
    field: "HooverPrice",
    direction: "asc",
  },
  page: 1,
  size: 50,
};

const initialDiamondSearchState = {
  pageLoaded: false,
  resultsLoaded: false,
  showAdvancedFilters: false,
  openPanel: false,
  currentTab: "Results",
  openHelpText: false,
  showCartSuccess: false,
  helpTextLabel: "",
  helpText: "",
  filters: [],
  advancedFilters: [],
  tableHeaders: [],
  mobileTableHeaders: [],
  tabletTableHeaders: [],
  sidePanelTableHeaders: [],
  diamonds: [],
  diamondCount: "",
  recentlyViewed: [],
  selected: [],
  selectedDiamond: {},
  cartPreview: [],
  openCartPreview: false,
  cartPreviewSingle: {},
  openCartPreviewSingle: false,
  searchQuery: initialDiamondSearch,
  checked: [],
};

const initialMeleeSearch = {
  fields: [],
  sort: {
    field: "EstimatedPrice",
    direction: "asc",
  },
  page: 1,
  size: 50,
};

const initialMeleeSearchState = {
  pageLoaded: false,
  resultsLoaded: false,
  openHelpText: false,
  showCartSuccess: false,
  standard: true,
  helpTextLabel: "",
  helpText: "",
  filters: [],
  collections: {},
  tableHeaders: [],
  mobileTableHeaders: [],
  tabletTableHeaders: [],
  diamonds: [],
  diamondCount: "",
  openCartPreview: false,
  cartPreview: {},
  searchQuery: initialMeleeSearch,
  strapiBody: "",
  strapiImage: null,
};

const initialBandsState = {
  pageLoaded: false,
  priceLoaded: false,
  message: "",
  messageType: "",
  style: "",
  productGroup: "",
  specialInstructions: "",
  productInfo: {},
  productFields: [],
  builder: [],
  complex: [],
  complex1: [],
  complex2: [],
  complex3: [],
  productTreatments: [],
  compatibleProducts: [],
  relatedProducts: [],
  icons: [],
  productSeries: {},
  price: null,
  productDetails: [],
  images: [],
  priceBreaks: [],
  daysToShip: "",
  estimatedShipDate: "",
  mto: false,
  metalColumns: {
    left: "",
    middle: "",
    right: "",
  },
  TopText: "",
  BottomText: "",
  ChartSizeSmall: false,
  strapiChart: null,
  sizeType: "standard",
  clear: false,
  validationErrors: [],
};

const states = {
  initialCartState: initialCartState,
  initialCreateAccountState: initialCreateAccountState,
  initialFormState: initialFormState,
  initialProductLandingState: initialProductLandingState,
  initialProductState: initialProductState,
  initialBarState: initialBarState,
  initialDiamondSearchState: initialDiamondSearchState,
  initialMeleeSearchState: initialMeleeSearchState,
  initialBandsState: initialBandsState,
};

export default states;
